import React from 'react';
import { Briefcase, Building2 } from 'lucide-react';
import type { PortfolioScope } from '../../hooks/useCandidates';

interface ScopeToggleProps {
  scope: PortfolioScope;
  onChange: (scope: PortfolioScope) => void;
  orgName?: string;
  entityLabel?: string; // 'Missions' | 'Talents'
}

const ScopeToggle: React.FC<ScopeToggleProps> = ({ scope, onChange, orgName, entityLabel = 'Éléments' }) => {
  return (
    <div className="flex items-center gap-1 bg-slate-100 border border-slate-200 rounded-lg p-1">
      <button
        onClick={() => onChange('portfolio')}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all whitespace-nowrap ${
          scope === 'portfolio'
            ? 'bg-amber-500 text-white shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        <Briefcase size={13} />
        Mes {entityLabel}
      </button>
      <button
        onClick={() => onChange('org')}
        className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all whitespace-nowrap ${
          scope === 'org'
            ? 'bg-amber-500 text-white shadow-sm'
            : 'text-slate-500 hover:text-slate-700'
        }`}
      >
        <Building2 size={13} />
        {entityLabel} {orgName || 'Org'}
      </button>
    </div>
  );
};

export default ScopeToggle;
